module.exports = __webpack_public_path__ + "images/emoji/man_with_turban.a5b5db7505534d6a9940.png";